// extracted by mini-css-extract-plugin
module.exports = {"root":"InputLabel-root-e1dc122fe9eadd9c84dd7009473dc7d7"};